import './scss/page-interactive.scss';

import 'lazysizes';
import 'lazysizes/plugins/video-embed/ls.video-embed';

import './offers-list';
import { createComment, readComments } from './components/comment';
import saveRating from './components/rating';

createComment();
readComments();
saveRating();
